export const DOC_GEN_USERS_SQL = `
WITH company_first AS (
  SELECT
    company_external_id,
    MIN(created_date_utc) AS first_doc_utc
  FROM public.document
  WHERE company_external_id IS NOT NULL
  GROUP BY 1
),
per_user AS (
  SELECT
    d.user_external_id,
    d.company_external_id,
    COUNT(*)                        AS doc_count,
    MIN(d.created_date_utc)         AS user_first_doc_utc,
    MAX(d.created_date_utc)         AS user_last_doc_utc
  FROM public.document d
  WHERE d.user_external_id IS NOT NULL
  GROUP BY 1, 2
)
SELECT
  TRIM(COALESCE(u.first_name,'') || ' ' || COALESCE(u.last_name,''))   AS user_name,
  u.email                                                              AS user_email,
  u.external_id                                                        AS user_external_id,
  c.name                                                               AS company_name,
  c.external_id                                                        AS company_external_id,
  c.country_code                                                       AS country_code,
  p.doc_count                                                          AS doc_count,
  EXTRACT(DAY FROM (NOW() - cf.first_doc_utc))::int                    AS days_since_company_first_doc,
  EXTRACT(DAY FROM (NOW() - p.user_first_doc_utc))::int                AS days_since_user_first_doc,
  p.user_first_doc_utc                                                 AS user_first_doc_utc,
  p.user_last_doc_utc                                                  AS user_last_doc_utc
FROM per_user p
LEFT JOIN public.users     u  ON u.external_id  = p.user_external_id
LEFT JOIN public.companies c  ON c.external_id  = p.company_external_id
LEFT JOIN company_first    cf ON cf.company_external_id = p.company_external_id
WHERE c.is_demo IS NOT TRUE
  AND c.deleted_date_utc IS NULL
ORDER BY p.doc_count DESC
`;

export type DocGenUserRow = {
  user_name: string;
  user_email: string;
  user_external_id: string;
  company_name: string;
  company_external_id: string;
  country_code: string | null;
  doc_count: number;
  days_since_company_first_doc: number | null;
  days_since_user_first_doc: number | null;
  user_first_doc_utc: string | null;
  user_last_doc_utc: string | null;
};

export function mapDocGenUserRows(columns: string[], rows: unknown[][]): DocGenUserRow[] {
  const idx: Record<string, number> = Object.fromEntries(columns.map((c, i) => [c, i] as const));
  const at = (r: unknown[], k: string): unknown => {
    const i = idx[k];
    return i === undefined ? undefined : r[i];
  };
  const num = (v: unknown): number => (v == null ? 0 : Number(v));
  const numOrNull = (v: unknown): number | null => (v == null ? null : Number(v));
  const str = (v: unknown): string => (v == null ? "" : String(v));
  const strOrNull = (v: unknown): string | null => (v == null ? null : String(v));
  return rows.map((r) => ({
    user_name: str(at(r, "user_name")).trim() || str(at(r, "user_email")),
    user_email: str(at(r, "user_email")),
    user_external_id: str(at(r, "user_external_id")),
    company_name: str(at(r, "company_name")) || "—",
    company_external_id: str(at(r, "company_external_id")),
    country_code: strOrNull(at(r, "country_code")),
    doc_count: num(at(r, "doc_count")),
    days_since_company_first_doc: numOrNull(at(r, "days_since_company_first_doc")),
    days_since_user_first_doc: numOrNull(at(r, "days_since_user_first_doc")),
    user_first_doc_utc: strOrNull(at(r, "user_first_doc_utc")),
    user_last_doc_utc: strOrNull(at(r, "user_last_doc_utc")),
  }));
}
